module.exports = __webpack_public_path__ + "static/media/tarjeta.103c548c.svg";